import { useState, useRef, useEffect } from "react";
import EmojiPicker from "emoji-picker-react";

const NotificationTitleInput = ({ label, value, onChange, required = false }) => {
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);

  const handleEmojiClick = (emojiData) => {
    onChange(value + emojiData.emoji); // append emoji to text
  };

  // Close picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  return (
    <div className="fieldrow" style={{ position: "relative" }} ref={pickerRef}>
      <label className="f_label">
        {label}
        {required &&  <span style={{ color: 'red' }}> *</span>}
      </label>
      <div style={{ position: "relative" }}>
        <input
          required
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="f_input"
          type="text"
          style={{ paddingRight: "40px" }} // space for emoji button
        />
        <button
          type="button"
          onClick={() => setShowPicker(!showPicker)}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            fontSize: "18px",
          }}
        >
          {showPicker ? "❌" : "🚢"}
        </button>
      </div>
      {showPicker && (
        <div
          style={{
            position: "absolute",
            zIndex: 10,
            top: "100%",
            right: 0,
          }}
        >
          <EmojiPicker onEmojiClick={handleEmojiClick} />
        </div>
      )}
    </div>
  );
};

export default NotificationTitleInput;
